// ** Icons Import
import { Award } from 'react-feather'

const Footer = () => {
  return (
    <p className='clearfix mb-0 text-center'>
      <span className='float-md-left d-block d-md-inline-block mt-25'>
        JBF CO., LTD. © 2007 All rights Reserved
        {/* <span className='d-none d-sm-inline-block'>, All rights Reserved</span> */}
      </span>
      <span className='float-md-right d-none d-md-block'>
        GOOD QUALITY FAIR PRICE
        <Award size={14} />
      </span>
    </p>
  )
}

export default Footer
